export const assessmentDelayCauseOptions = [
    {
        field: "delayCauseProviderClinicalInformation",
        label: "Provider delay in supplying clinical information/documentation",
    },
    {
        field: "delayCauseFurtherInformationResponse",
        label: "Delayed response to request for further information",
    },
    {
        field: "delayCausePatientRecordsAccess",
        label: "Difficulty obtaining access to patient records",
    },
    {
        field: "delayCauseProviderArrangingAssessment",
        label: "Provider delay in arranging assessment",
    },
    {
        field: "delayCauseProviderRescheduled",
        label: "Provider rescheduled assessment",
    },
    {
        field: "delayCauseInterpreterArrangements",
        label: "Interpreter arrangements",
    },
    {
        field: "delayCauseTravelOrLogistics",
        label: "Travel or logistical difficulties",
    },
    {
        field: "delayCauseSecurityOrEscorting",
        label: "Security/escorting arrangements unavailable",
    },
    {
        field: "delayCausePatientTransferred",
        label: "Patient transferred between providers/wards",
    },
    {
        field: "delayCausePatientAbsent",
        label: "Patient absent from ward/hospital at arranged assessment",
    },
    {
        field: "delayCausePatientTooUnwell",
        label: "Patient too unwell to participate in assessment",
    },
    {
        field: "delayCauseInappropriateStatutoryConsultee",
        label: "Inappropriate Statutory consultee",
    },
    {
        field: "delayCauseContactingClinician",
        label: "Difficulty or unable to contact Responsible Clinician/Approved Clinician",
    },
    {
        field: "delayCauseContactingStatutoryConsultee",
        label: "Difficulty or unable to contact Statutory Consultee",
    },
    {
        field: "delayCauseStatutoryConsulteeMeeting",
        label: "Difficulty arranging Statutory Consultee meeting",
    },
    {
        field: "delayCauseProviderArrangingInterpreter",
        label: "Provider delay in arranging interpreter",
    },
    {
        field: "delayCauseRemoteAccess",
        label: "IT/remote access issues (if virtual reviews occur)",
    },
    { field: "delayCauseOther", label: "Other" },
];
/** A delay of less than a day is recorded as 1. */
export const minAssessmentDelayDays = 1;
/** The answers that only exist when the SOAD says the assessment was delayed. */
export const assessmentDelayDetailFields = [
    ...assessmentDelayCauseOptions.map((o) => o.field),
    "delayDetails",
    "delayDays",
];
export const assessmentDelayFields = [
    "delayedOutsideSoadControl",
    ...assessmentDelayDetailFields,
];
//# sourceMappingURL=srfAssessmentDelays.js.map